export default __webpack_public_path__ + "static/media/logo.b096f1fe.svg";